export default __webpack_public_path__ + "static/media/setting-fill.8a57c757.svg";